import React from 'react';
import styled, { css } from 'styled-components';

import { ManualCSSColors } from 'app/shared/theme';
import CloseButton from 'app/shared/components/atoms/CloseButton';
import { CloseIcon } from 'app/shared/components/atoms/IconLibrary';

interface Props {
  onClose?: () => void;
  backgroundColor?: ManualCSSColors;
  dataQaid?: string;
  closeButtonDataQaid?: string;
}

const AnchoredCloseButton = styled(CloseButton)`
  ${({ theme }) => css`
    position: absolute;
    top: 0;
    right: 0;
    padding: 24px;
    margin: 0px;

    ${theme.media.xs`
      padding: 15px 17px;
    `}

    ${theme.media.sm`
      padding: 16px;
    `}
  `}
`;

const ModalUnderlay = styled.div`
  ${({ theme }) => css`
    left: 0;
    top: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    z-index: ${theme.zIndex.genericSmallModal};
    overflow-y: auto;
    padding: 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  `}
`;

const ModalContainer = styled.div`
  ${({ theme }) => css`
    width: 90%;
    max-width: 320px;

    ${theme.media.md`
      width: 60%;
      max-width: 555px;
    `}

    ${theme.media.lg`
      width: 50%;
      max-width: 595px;
    `}

    ${theme.media.xl`
      width: 45%;
      max-width: 595px;
    `}
  `}
`;

const ModalMainContainer = styled.div<any>`
  ${({ theme, backgroundColor }) => css`
    background-color: ${theme.colors[backgroundColor]};
    padding: 50px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: ${theme.borderRadius.default};
    position: relative;

    ${theme.media.md`
      padding: 60px 50px;
    `}
  `}
`;

const ModalContent: React.FC<React.PropsWithChildren<Props>> = ({
  onClose,
  backgroundColor = 'silverSpringsForModal',
  dataQaid = 'confirm-modal',
  closeButtonDataQaid = 'confirmation-modal-close-btn',
  children,
}) => {
  return (
    <ModalMainContainer data-qaid={dataQaid} backgroundColor={backgroundColor}>
      {onClose && (
        <AnchoredCloseButton onClick={onClose} data-qaid={closeButtonDataQaid}>
          <CloseIcon />
        </AnchoredCloseButton>
      )}
      <>{children}</>
    </ModalMainContainer>
  );
};

export const GenericSmallModal: React.FC<React.PropsWithChildren<Props>> = (
  props
) => {
  return (
    <ModalUnderlay>
      <ModalContainer>
        <ModalContent {...props} />
      </ModalContainer>
    </ModalUnderlay>
  );
};
